import type { JSX } from "react";
import { CSSProperties } from 'react';
import classes from './CheckBox.module.css'
import { CheckCheckedIcon, CheckUncheckedIcon } from '../Icons';

interface Props {
    title?: string;
    error?: string;
    checked?: boolean;
    disabled?: boolean;
    onClick?: () => void;
    className?: string;
    style?: CSSProperties;
    icon?: JSX.Element | null;
    type?: 'default' | 'primary' | 'secondary';
}

const CheckBox = ({
    title,
    error,
    checked = false,
    disabled = false,
    onClick,
    className,
    style,
    icon = null,
    type = 'default',
}: Props) => {
    const classNames = [classes.CheckBox, className];

    if (disabled) classNames.push(classes.disabled);
    if (checked) classNames.push(classes.checked);
    if (type === 'primary') classNames.push(classes.primary);

    return (
        <div className={classNames.join(' ')}
            style={style}
            onClick={!disabled ? onClick : undefined}
            title={disabled ? error : ''}
        >
            {checked ? (
                <CheckCheckedIcon className={classes.icon} width={20} />
            ): (
                <CheckUncheckedIcon className={classes.icon} width={20} />
            )}

            {title && (
                <p className={classes.title}>{icon}{title}</p>
            )}
        </div>
    )
}

export default CheckBox